export default "__VITE_ASSET__681709ab__"